import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from './icons/icon_log_out.svg';
import { filterItems, getMenuItemsTop, menuItemsBottom } from './menu-item-util';
import { SidebarMenuItem } from './sidebar-menu-item';
import { SidebarProfile } from './sidebar-profile';
import { logout } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import './sidebar-v2.css';
export const SidebarV2 = ({ toggleScroll }) => {
    const { state, dispatch } = useGlobalState();
    const navigate = useNavigate();
    const user = {
        ...state.user
    };
    const signOff = () => {
        dispatch(logout());
        navigate('/signin');
    };
    /*
     * Returns the list of items that can be rendered.
     * NOTE: The filter method determines which items the user has access to
     * Use this to conditionally add items based on a feature flag
     */
    const topItems = filterItems(user, getMenuItemsTop(!!state.account?.hasAnalyticsAccess));
    const bottomItems = filterItems(user, menuItemsBottom);
    const [open, setOpen] = useState(false);
    const [width, setWidth] = useState(0);
    useEffect(() => {
        if (width >= 768) {
            toggleScroll(false);
            setOpen(true);
        }
        else {
            setOpen(false);
            toggleScroll(false);
        }
    }, [width]);
    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const handleReset = () => {
        setOpen(false);
        toggleScroll(false);
    };
    const isMobile = width < 768;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "hamburger" },
            React.createElement("i", { className: "fa fa-bars", onClick: () => {
                    toggleScroll((prevState) => !prevState);
                    setOpen((prevState) => !prevState);
                }, style: { color: 'black', fontSize: '20px' } }),
            React.createElement("img", { alt: "logo", src: "assets/vouched_logo.svg" })),
        open && (React.createElement("div", { className: "sidebar-v2" },
            React.createElement("div", { className: "sidebar-container" },
                React.createElement("span", { className: "close", onClick: () => {
                        toggleScroll((prevState) => !prevState);
                        setOpen((prevState) => !prevState);
                    } }, "x"),
                React.createElement("div", null,
                    React.createElement("div", { className: "logo-container" },
                        React.createElement("img", { alt: "logo", className: "sidebar__logo", src: "assets/vouched_logo.svg" })),
                    React.createElement(SidebarProfile, { menuReset: isMobile ? handleReset : undefined }),
                    topItems.map((item) => (React.createElement(SidebarMenuItem, { item: item, key: item.name, menuReset: isMobile ? handleReset : undefined }))),
                    React.createElement("div", null,
                        React.createElement("hr", { className: "divider" }),
                        React.createElement("div", { className: "divider__label" }, "Documentation")),
                    bottomItems.map((item) => (React.createElement(SidebarMenuItem, { item: item, key: item.name, menuReset: isMobile ? handleReset : undefined })))),
                React.createElement("div", null,
                    React.createElement("div", { className: "logout", "data-cy": "Logout", onClick: () => {
                            signOff();
                        } },
                        React.createElement("div", { className: "logout__items" },
                            React.createElement(LogoutIcon, null),
                            React.createElement("span", null, "Log Out")))))))));
};
